var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 6,
    viewBox: "0 0 22 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 0.666748C1.55 0.666748 0.5 1.71675 0.5 3.00008C0.5 4.28341 1.55 5.33341 2.83333 5.33341C4.11667 5.33341 5.16667 4.28341 5.16667 3.00008C5.16667 1.71675 4.11667 0.666748 2.83333 0.666748ZM19.1667 0.666748C17.8833 0.666748 16.8333 1.71675 16.8333 3.00008C16.8333 4.28341 17.8833 5.33341 19.1667 5.33341C20.45 5.33341 21.5 4.28341 21.5 3.00008C21.5 1.71675 20.45 0.666748 19.1667 0.666748ZM11 0.666748C9.71667 0.666748 8.66667 1.71675 8.66667 3.00008C8.66667 4.28341 9.71667 5.33341 11 5.33341C12.2833 5.33341 13.3333 4.28341 13.3333 3.00008C13.3333 1.71675 12.2833 0.666748 11 0.666748Z",
    fill: "#414343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more_icon.c56f210c47c6aa3dcbc8a983a5b25a39.svg";
export { ForwardRef as ReactComponent };